export const GETBADGEUSERS = "GETBADGEUSERS";
export const SETBADGEUSERS = "SETBADGEUSERS";
